interface Testimonial {
  quote: string;
  author: string;
}

interface TestimonialTickerProps {
  testimonials: Testimonial[];
}

export default function TestimonialTicker({ testimonials }: TestimonialTickerProps) {
  return (
    <div className="w-screen py-20 overflow-hidden bg-[#F7F7F7] mb-16 md:mb-32">
      <h2 className="text-center headline-large mb-16">Testimonios</h2>
      <div className="relative w-screen overflow-hidden">
        <div className="absolute left-0 w-[20%] h-full bg-gradient-to-r from-[#F7F7F7] to-transparent z-10"></div>
        <div className="absolute right-0 w-[20%] h-full bg-gradient-to-l from-[#F7F7F7] to-transparent z-10"></div>
        <div className="flex animate-scroll">
          {/* First set of testimonials */}
          {testimonials.map((testimonial, index) => (
            <div key={`testimonial-1-${index}`} className="flex-shrink-0 mx-8 md:mx-16 w-[280px] md:w-[400px]">
              <div className="bg-white p-6 md:p-8 rounded-lg">
                <p className="body-medium mb-4">"{testimonial.quote}"</p>
                <p className="body text-gray-600">- {testimonial.author}</p>
              </div>
            </div>
          ))}
          {/* Duplicate testimonials for seamless scrolling */}
          {testimonials.map((testimonial, index) => (
            <div key={`testimonial-2-${index}`} className="flex-shrink-0 mx-8 md:mx-16 w-[280px] md:w-[400px]">
              <div className="bg-white p-6 md:p-8 rounded-lg">
                <p className="body-medium mb-4">"{testimonial.quote}"</p>
                <p className="body text-gray-600">- {testimonial.author}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
} 